import { Alert } from '@mui/material';
import { useEffect } from 'react';

import { useCockpitContext } from '../CockpitContextProvider/CockpitContextProvider.hook';
import { ChatThinkingMessage } from '@/legacy/components/Chat/ChatMessage/ChatThinkingMessage';
import { conversationLayoutClasses } from '@/legacy/components/ConversationLayout/ConversationLayout.styled';
import { ChatConversation } from '~/components/Chat/ChatConversation';
import { MessageSubmissionContextProvider } from '~/components/Chat/MessageSubmissionContextProvider/MessageSubmissionContextProvider';
import { CircularProgressCentered } from '~/components/CircularProgressCentered/CircularProgressCentered';
import { Disclaimer } from '~/components/ConversationInput/components/Disclaimer/Disclaimer';
import { ConversationInput } from '~/components/ConversationInput/ConversationInput';
import { ConversationLayout } from '~/components/ConversationLayout/ConversationLayout';
import { useAgentSubmitHandler } from '~/routes/IntakeChat/hooks/useAgentSubmitHandler';
import { useChat } from '~/routes/IntakeChat/hooks/useChat';

export const Thread = () => {
  const { threadId, initialMessage, clearInitialMessage } = useCockpitContext();
  const { isLoading, chat, agentId } = useChat(threadId);
  const { status, messages = [], sendMessage, error } = chat ?? {};

  const handleSubmit = useAgentSubmitHandler(agentId, sendMessage);

  useEffect(() => {
    // if we have a query and the chat is not loading, start a conversation
    if (initialMessage && messages.length === 0 && status === 'ready' && sendMessage) {
      clearInitialMessage();
      sendMessage({
        role: 'user',
        parts: [{ type: 'text', text: initialMessage }],
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [status, messages, initialMessage]);

  const isInputDisabled = isLoading || (status !== 'ready' && status !== 'error');
  const isInputLoading = status === 'submitted' || status === 'streaming';

  return (
    <ConversationLayout
      sx={{
        [`& .${conversationLayoutClasses.conversationContainer}, & .${conversationLayoutClasses.inputContainer} > *`]: {
          maxWidth: {
            xl: 1280,
          },
        },
        [`& .${conversationLayoutClasses.inputContainer}`]: {
          background: `linear-gradient(0deg, #FAFAFA, 95%, transparent)`,
        },
      }}
      input={<ConversationInput disabled={isInputDisabled} isLoading={isInputLoading} onSubmit={handleSubmit} />}
      disclaimer={<Disclaimer />}
    >
      {isLoading && <CircularProgressCentered />}
      {messages.length > 0 && sendMessage && (
        <MessageSubmissionContextProvider sendMessage={sendMessage}>
          <ChatConversation messages={messages} status={status}>
            {error && <Alert severity="error">{error.message}</Alert>}
            {status === 'submitted' && <ChatThinkingMessage />}
          </ChatConversation>
        </MessageSubmissionContextProvider>
      )}
    </ConversationLayout>
  );
};
